import React from "react";
import "../pages/Login/Login.css";
const imagePath = "/static/media/twitter.9614a59eb1b7861a29ca.png";

const PageLoading = () => {
  return (
    <div
      style={{ display: "flex",flexDirection : "column",height:"100vh", alignItems:"center", width:"100%", justifyContent: "center" }}
    >
      <img className="image1" src={imagePath} alt="Description of the image" />
      Loading...
    </div>
  );
};

export default PageLoading;
